'use strict';

angular.module('app.performanceReportTimeline', [])
    .directive('performanceReportTimelineDirective', function () {
        return {
            controller: 'performanceReportTimelineCtrl',
            templateUrl: 'app/measure/performanceReport/performanceReportTimeline/performanceReportTimeline.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })